"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapLegend = exports.HeatmapLegendItem = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var format_1 = require("../../../../../../../app/util/format");
var useHeatmapLegendItemStyles = styles_1.makeStyles(function () { return ({
    itemRoot: {
        flex: 1,
        height: 13,
        backgroundColor: function (props) { return props.color; },
        marginTop: -8,
        marginRight: 4,
        '&:last-child': {
            marginRight: 0,
        },
    },
}); });
function HeatmapLegendItem(_a) {
    var color = _a.color;
    var classes = useHeatmapLegendItemStyles({ color: color });
    return react_1.default.createElement("div", { className: classes.itemRoot });
}
exports.HeatmapLegendItem = HeatmapLegendItem;
var useHeatmapLegendStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        maxWidth: 500,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    row: {
        display: 'flex',
        maxWidth: 500,
        justifyContent: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    ticks: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 4,
    },
    tickLeading: {
        width: 0,
        display: 'flex',
        justifyContent: 'start',
        fontSize: theme.typography.caption.fontSize,
    },
    tick: {
        width: 0,
        display: 'flex',
        justifyContent: 'center',
        fontSize: theme.typography.caption.fontSize,
    },
    tickTrailing: {
        width: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        fontSize: theme.typography.caption.fontSize,
    },
}); });
function HeatmapLegend(_a) {
    var minClicks = _a.minClicks, maxClicks = _a.maxClicks;
    var theme = styles_1.useTheme();
    var classes = useHeatmapLegendStyles();
    var min = minClicks;
    var max = maxClicks;
    var mid = (min + max) / 2;
    var minmid = (min + mid) / 2;
    var midmax = (mid + max) / 2;
    var ticks = [min, minmid, mid, midmax, max];
    var ticksCount = 5;
    var getTickStyle = function (index, length) {
        if (index === 0) {
            return classes.tickLeading;
        }
        if (index >= length - 1) {
            return classes.tickTrailing;
        }
        return classes.tick;
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.row },
            react_1.default.createElement(HeatmapLegendItem, { color: theme.palette.secondary.light }),
            react_1.default.createElement(HeatmapLegendItem, { color: theme.palette.secondary.main }),
            react_1.default.createElement(HeatmapLegendItem, { color: theme.palette.primary.main }),
            react_1.default.createElement(HeatmapLegendItem, { color: theme.palette.secondary.dark })),
        react_1.default.createElement("div", { className: classes.ticks }, ticks.map(function (tick, id) {
            return (react_1.default.createElement("div", { className: getTickStyle(id, ticksCount), key: tick }, format_1.compactNumberFormatter(tick)));
        }))));
}
exports.HeatmapLegend = HeatmapLegend;
